import React, { useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { FullScreenLoader } from "../Components/Loader";
import { logIn } from "../repositories/InfrakitRepository";
import { Alert } from "@mui/material";

export default function InfrakitLogin() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("infrakitToken");
    const token = JSON.parse(authToken || "{}").accessToken;
    token && navigate("/infrakit/projects");
  }, [navigate]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);
    const data = new FormData(event.currentTarget);

    logIn(data)
      .then((res) => {
        setError(false);
        localStorage.setItem("infrakitToken", JSON.stringify(res.data));
        navigate("/infrakit/projects");
      })
      .catch(() => setError(true))
      .finally(() => setIsLoading(false));
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src="https://infrakit.atlassian.net/s/tod1zk/b/4/4dfcd128b56e7dd5dce7882155d48d6a/_/jira-logo-scaled.png"
          alt="logo"
        />
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="username"
            label="Infrakit Username"
            name="username"
            autoComplete="username"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Infrakit Password"
            type="password"
            id="password"
            autoComplete="password"
          />
          {error && (
            <Alert severity="error" className="mb-3">
              Invalid credentials. Try again.
            </Alert>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Login
          </Button>
        </Box>
      </Box>
      {isLoading && <FullScreenLoader isLoading />}
    </Container>
  );
}
